<div class="reviews-outer" [formGroup]="donationForm">
  <h2 class="trinidad-bold">Donate the cost of a bundle of firewood.</h2>
  <p class="wizard-paragraph _12px">
    We want to keep on offering great sites. Donations go to CurbNTurf towards overhead of maintaining our bookdocking
    sites and to caretaker of the site. Caretakers are the ones that have entered the most information about the site,
    so we want to reward them for that information.
  </p>
  <div class="donation-option-outer">
    <div (click)="setAmount(5)">
      <a class="cnt-button-secondary w-button" [class.selected]="donationAmount === 5"> $5 </a>
    </div>
    <div (click)="setAmount(10)">
      <a class="cnt-button-secondary w-button" [class.selected]="donationAmount === 10"> $10 </a>
    </div>
    <div (click)="setAmount(20)">
      <a class="cnt-button-secondary w-button" [class.selected]="donationAmount === 20"> $20 </a>
    </div>
    <div (click)="setAmount(0)">
      <a
        class="cnt-button-secondary w-button"
        [class.selected]="donationAmount !== 20 && donationAmount !== 10 && donationAmount !== 5"
      >
        other
      </a>
    </div>
    <a class="large-option cnt-button-secondary w-button" (click)="setAmount(0)" *ngIf="!customAmount">
      Enter amount ($5 Minimum)
    </a>
    <div class="large-form-entry large-option cnt-button-secondary w-button" *ngIf="customAmount">
      <input
        #amountEl
        type="number"
        placeholder="Enter amount ($5 Minimum)"
        formControlName="amount"
        style="width: 100%"
      />
    </div>
  </div>
  <br />
  <h4>CurbNTurf accepts major credit cards.</h4>
  <curbnturf-cards-accepted></curbnturf-cards-accepted>
  <curbnturf-credit-card-editing #creditCardEditing> </curbnturf-credit-card-editing>
  <a (click)="onMakeDonation($event)" class="button trinidad center w-button"> Make Donation </a>
</div>
